import NiceModal from "@ebay/nice-modal-react";
import { useState } from "react";
import { canv } from "@/canv/global";
import { frameOverlappedManager } from "@/elements/frame/FrameOverlappedManager";
import { PresentationWidget } from "@/elements/Presentation/Presentation";
import { PresentationIsDeletedNotification } from "@/interface/ui/notifications/presentationIsDeleted";
import type { PresentationData } from "../types";
import styles from "./PresentationsList.module.scss";
import { PresentationsListItem } from "./PresentationsListItem";

type PresentationsListProps = {
    setCurrentPresentation: (data: PresentationData | null) => void;
    presentations: PresentationData[];
};

export const PresentationsList = ({
    presentations,
    setCurrentPresentation,
}: PresentationsListProps) => {
    const [openedMenuUID, setOpenedMenuUID] = useState<string | null>(null);

    const handleDelete = (presentation: PresentationData) => {
        const groupsToDelete = frameOverlappedManager.collectGroupsForDeletion([
            canv.canvasController.FindByUID(presentation.UID)?.parent,
        ]);

        canv.eventManager.openRecord();
        for (let i = 0; i < groupsToDelete.length; i++) {
            canv.canvasController.deleteProcessor(groupsToDelete[i]);
        }
        canv.eventManager.closeRecord();
        NiceModal.show(PresentationIsDeletedNotification, {
            text: "Презентация удалена",
            duration: 3000,
            uid: presentation.UID,
        });
    };

    const handleRename = (UID: string, newName: string) => {
        const presentation = canv.canvasController.FindByUID(UID);
        if (presentation && presentation instanceof PresentationWidget) {
            presentation.setName(newName);
            canv.widgetMenu.reopen();
        }
    };

    const isEditorOrOwner = !!canv.isBoardModeEditOrOwner();

    return (
        <div className={styles.slideList}>
            {presentations.map((presentation) => (
                <PresentationsListItem
                    key={presentation.UID}
                    data={presentation}
                    onSelect={setCurrentPresentation}
                    onDelete={handleDelete}
                    onRename={handleRename}
                    isMenuOpen={openedMenuUID === presentation.UID}
                    onMenuOpen={() => setOpenedMenuUID(presentation.UID)}
                    onMenuClose={() => setOpenedMenuUID(null)}
                    isEditorOrOwner={isEditorOrOwner}
                />
            ))}
        </div>
    );
};
